// import React from 'react';

// const BusRatesTable = () => {
//   const ratesData = [
    
//     { seater: "SWIFT DESIRE", mumbai: "4+1", mahabaleshwar: "13", specialPermitNumber: "917387507373", driver: "Extra", parking: "Extra" },
//     { seater: "AURA", mumbai: "4+1", mahabaleshwar: "13", specialPermitNumber: "917387507373", driver: "Extra", parking: "Extra" },
//     { seater: "TOYOTA ETIOS", mumbai: "4+1", mahabaleshwar: "14", specialPermitNumber: "917387507373", driver: "Extra", parking: "Extra" },
//     { seater: "ERITGA", mumbai: "6+1", mahabaleshwar: "15", specialPermitNumber: "917387507373", driver: "Extra", parking: "Extra" },
//     { seater: "INNOVA", mumbai: "6+1", mahabaleshwar: "18", specialPermitNumber: "917387507373", driver: "Extra", parking: "Extra" },
//     { seater: "INNOVA CRYSTA", mumbai: "6+1", mahabaleshwar: "21", specialPermitNumber: "917387507373", driver: "Extra", parking: "Extra" },
//     { seater: "INNOVA HYCROSS", mumbai: "6+1", mahabaleshwar: "25", specialPermitNumber: "917387507373", driver: "Extra", parking: "Extra" },
//     { seater: "TEMPO TRAVELLER", mumbai: "13/17 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "917387507373", driver: "Extra", parking: "Extra" },
//     { seater: "MINI BUS", mumbai: "20 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "917387507373", driver: "Extra", parking: "Extra" },
//     { seater: "BUS", mumbai: "32-52", mahabaleshwar: "ON CALL", specialPermitNumber: "917387507373", driver: "Extra", parking: "Extra" },
//   ];

//   const tableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//     margin: "20px auto",
//   };

//   const thStyle = {
//     backgroundColor: "#F26722",
//     color: "white",
//     padding: "8px",
//     border: "1px solid #ddd",
//   };

//   const tdStyle = {
//     padding: "8px",
//     border: "1px solid #ddd",
//     textAlign: "center",
//   };

//   const trEvenStyle = {
//     backgroundColor: "#f2f2f2",
//   };

//   const handleWhatsAppClick = (number, seater) => {
//     console.log(`Opening WhatsApp for ${seater} with number ${number}`);
//     const message = `Hi, I would like to inquire about the rates for the ${seater}.`;
//     const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
//     window.open(url, '_blank');
//   };

//   return (
//     <div className="container p-0">
//       <h3>Our Packages</h3>
//       <div className="table-responsive">
//         <table style={tableStyle}>
//           <thead>
//             <tr>
//               <th style={thStyle}>Bus Name</th>
//               <th style={thStyle}>Seater</th>
//               <th style={thStyle}>Per KM</th>
//               <th style={thStyle}>Driver Food</th>
//               <th style={thStyle}>Toll Parking</th>
//               <th style={thStyle}>Book Now</th>
//             </tr>
//           </thead>
//           <tbody>
//             {ratesData.map((row, index) => (
//               <tr key={index} style={index % 2 === 0 ? trEvenStyle : null}>
//                 <td style={tdStyle}>{row.seater}</td>
//                 <td style={tdStyle}>{row.mumbai}</td>
//                 <td style={tdStyle}>{row.mahabaleshwar}</td>
//                 <td style={tdStyle}>{row.driver}</td>
//                 <td style={tdStyle}>{row.parking}</td>
//                 <td style={tdStyle}>
//                   <button
//                     onClick={() => handleWhatsAppClick(row.specialPermitNumber, row.seater)}
//                     style={{
//                       cursor: "pointer",
//                       backgroundColor: "#F26722",
//                       padding: "10px",
//                       borderRadius: "8px",
//                       color: "white",
//                     }}
//                   >
//                     Book Now
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default BusRatesTable;



import React from "react";

const BusRatesTable = () => {

  const acMumbaiMahabaleshwar = [
    { bus: "13 Seater", mumbai: "₹9500/-", mahabaleshwar: "₹9000/-", extraKm: "25", permit: "₹800" },
    { bus: "17 Seater", mumbai: "₹10500/-", mahabaleshwar: "₹10000/-", extraKm: "26", permit: "₹800" },
    { bus: "20 Seater", mumbai: "₹11500/-", mahabaleshwar: "₹10500/-", extraKm: "27", permit: "₹800" },
    { bus: "26 Seater", mumbai: "₹15000/-", mahabaleshwar: "₹14000/-", extraKm: "38", permit: "₹1000" },
    { bus: "32 Seater", mumbai: "₹18000/-", mahabaleshwar: "₹17000/-", extraKm: "48", permit: "₹1500" },
    { bus: "35 Seater", mumbai: "₹19000/-", mahabaleshwar: "₹18000/-", extraKm: "50", permit: "₹1500" },
    { bus: "45 Seater", mumbai: "₹24000/-", mahabaleshwar: "₹22000/-", extraKm: "65", permit: "₹1500" },
  ];

  const nonAcMumbaiMahabaleshwar = [
    { bus: "13 Seater", mumbai: "₹8500/-", mahabaleshwar: "₹8000/-", extraKm: "21", permit: "₹800" },
    { bus: "17 Seater", mumbai: "₹9000/-", mahabaleshwar: "₹8500/-", extraKm: "22", permit: "₹800" },
    { bus: "20 Seater", mumbai: "₹10500/-", mahabaleshwar: "₹9500/-", extraKm: "24", permit: "₹800" },
    { bus: "26 Seater", mumbai: "₹13000/-", mahabaleshwar: "₹12000/-", extraKm: "34", permit: "₹1000" },
    { bus: "32 Seater", mumbai: "₹13500/-", mahabaleshwar: "₹12500/-", extraKm: "34", permit: "₹1500" },
    { bus: "35 Seater", mumbai: "₹14500/-", mahabaleshwar: "₹14500/-", extraKm: "45", permit: "₹1500" },
    { bus: "45 Seater", mumbai: "₹18000/-", mahabaleshwar: "₹17000/-", extraKm: "48", permit: "₹1500" },
  ];

  const localAcRates = [
    { bus: "13 Seater", rate: "₹5000/-", extraKm: "25", extraHr: "₹300" },
    { bus: "17 Seater", rate: "₹5500/-", extraKm: "26", extraHr: "₹300" },
    { bus: "20 Seater", rate: "₹6000/-", extraKm: "27", extraHr: "₹300" },
    { bus: "26 Seater", rate: "₹8500/-", extraKm: "38", extraHr: "₹500" },
    { bus: "32 Seater", rate: "₹11000/-", extraKm: "48", extraHr: "₹700" },
    { bus: "35 Seater", rate: "₹12000/-", extraKm: "50", extraHr: "₹700" },
    { bus: "45 Seater", rate: "₹13500/-", extraKm: "65", extraHr: "₹1000" },
  ];

  const localNonAcRates = [
    { bus: "13 Seater", rate: "₹4500/-", extraKm: "21", extraHr: "₹300" },
    { bus: "17 Seater", rate: "₹5500/-", extraKm: "22", extraHr: "₹300" },
    { bus: "20 Seater", rate: "₹5000/-", extraKm: "24", extraHr: "₹300" },
    { bus: "26 Seater", rate: "₹7000/-", extraKm: "32", extraHr: "₹500" },
    { bus: "32 Seater", rate: "₹5500/-", extraKm: "33", extraHr: "₹700" },
    { bus: "35 Seater", rate: "₹9000/-", extraKm: "44", extraHr: "₹700" },
    { bus: "45 Seater", rate: "₹10000/-", extraKm: "48", extraHr: "₹1000" },
  ];

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "40px",
  };

  const thStyle = {
    backgroundColor: "#F26722",
    color: "#fff",
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
  };

  const tdStyle = {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
  };

  const sectionTitle = {
    marginBottom: "15px",
    fontSize: "24px",
    fontWeight: "700",
  };

  const renderMumbaiTable = (title, data) => (
    <>
      <h3 style={sectionTitle}>{title}</h3>

      <div className="table-responsive">
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>BUSES</th>
              <th style={thStyle}>Mumbai upto 350 KM</th>
              <th style={thStyle}>Mahabaleshwar Up to 300 KM</th>
              <th style={thStyle}>Extra KM</th>
              <th style={thStyle}>Special Permit</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f8f8f8" : "#fff",
                }}
              >
                <td style={tdStyle}>{item.bus}</td>
                <td style={tdStyle}>{item.mumbai}</td>
                <td style={tdStyle}>{item.mahabaleshwar}</td>
                <td style={tdStyle}>{item.extraKm}</td>
                <td style={tdStyle}>{item.permit}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );

  const renderLocalTable = (title, data) => (
    <>
      <h3 style={sectionTitle}>{title}</h3>

      <div className="table-responsive">
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>BUSES</th>
              <th style={thStyle}>Rate</th>
              <th style={thStyle}>Extra KM</th>
              <th style={thStyle}>Extra HR</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f8f8f8" : "#fff",
                }}
              >
                <td style={tdStyle}>{item.bus}</td>
                <td style={tdStyle}>{item.rate}</td>
                <td style={tdStyle}>{item.extraKm}</td>
                <td style={tdStyle}>{item.extraHr}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );

  return (
    <div className="container py-4">

      {renderMumbaiTable(
        "Rates for AC Mumbai and Mahabaleshwar",
        acMumbaiMahabaleshwar
      )}

      {renderMumbaiTable(
        "Rates for Non AC Mumbai and Mahabaleshwar",
        nonAcMumbaiMahabaleshwar
      )}

      {renderLocalTable(
        "Local Rates for 8 Hrs / 80 KM AC",
        localAcRates
      )}

      {renderLocalTable(
        "Local Rates for 8 Hrs / 80 KM Non AC",
        localNonAcRates
      )}

    </div>
  );
};

export default BusRatesTable;